import { splitDatesIntoIntervals } from "@cmp-src/data-display/date-intervals/splitDatesIntoIntervals";

import { cn } from "@gettactic/helpers";
import { useAuthenticated } from "@gettactic/hooks";
import { DateValue } from "@v2/components/calendar/types";
import { IconProps } from "@v2/components/display/Icon/Icon";
import { Button, ButtonProps } from "@v2/components/ui/button";
import { ArrowDownIcon, Calendar1Icon } from "@v2/icons";
import React from "react";
const arrow = <span className="px-1 text-neutral-500"> ➝ </span>;
export interface CalendarTriggerProps {
  dates: DateValue | undefined;
  customText?: string;
  buttonProps?: ButtonProps;
  icon?: React.FC<IconProps>;
  className?: string;
  separator?: React.ReactNode;
}

const classes = {
  Button: "w-[272px] h-[42px]",
  Label: "flex flex-1 flex-row justify-center items-center",
  Icon: "size-4 text-neutral-600 hidden md:block",
  IntervalItem: "flex flex-row items-center justify-center",
  IntervalSeparator: "mr-1",
  DropdownArrow: "size-4 ml-[5px] hidden md:block"
};

export const CalendarTrigger = React.forwardRef<
  React.ComponentRef<typeof Button>,
  CalendarTriggerProps
>(
  (
    { dates, buttonProps, icon, className, customText, separator = "," },
    ref
  ) => {
    const {
      userContext: { authenticatedUser }
    } = useAuthenticated();
    const intervals = splitDatesIntoIntervals(
      dates,
      authenticatedUser?.user?.date_format,
      true
    );

    return (
      <Button
        variant="trigger"
        className={cn(classes.Button, className)}
        ref={ref}
        {...buttonProps}
      >
        {React.createElement(icon || Calendar1Icon, {
          className: classes.Icon
        })}
        <span className={classes.Label}>
          {customText ? (
            <>{customText}</>
          ) : !intervals || !intervals.length ? (
            <>Select a date</>
          ) : (
            intervals.map((interval, index) =>
              interval.length < 3 ? (
                <span
                  className={classes.IntervalItem}
                  key={`date-interval-${interval[0]}`}
                >
                  <span>{interval[0]}</span>
                  {interval.length === 2 && <span>{arrow}</span>}
                  <span>{interval[1]}</span>
                  {index < intervals.length - 1 && (
                    <span className={classes.IntervalSeparator}>
                      {separator}
                    </span>
                  )}
                </span>
              ) : (
                <span key={`date-interval-${interval[0]}`}>
                  {interval[0]}
                  {arrow}
                  {interval[1]}
                </span>
              )
            )
          )}
          <ArrowDownIcon className={classes.DropdownArrow} />
        </span>
      </Button>
    );
  }
);
